import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Register from './components/Register';
import Login from './components/Login';
import MyOrders from './components/MyOrders';
import OrderImport from './components/OrderImport';
import MyBatches from './components/MyBatches';
import UserBatchManagement from './components/BatchManagement';
import OrderTracking from './components/OrderTracking';
import PublicOrderTracking from './components/PublicOrderTracking';
import ChangePassword from './components/ChangePassword';
import UpdateAddress from './components/UpdateAddress';
import CanUpdateAddressRoute from './components/CanUpdateAddressRoute';
import CustomerScanPrint from './components/CustomerScanPrint';
import AdminScanPrint from './components/admin/AdminScanPrint';
import StaffScanPrint from './components/staff/StaffScanPrint';
import OrderImportStaff from './components/staff/OrderImportStaff';
import ExceptionHandling from './components/staff/ExceptionHandling';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/admin/AdminRoute';
import ManagerRoute from './components/admin/ManagerRoute';
import AdminLayout from './components/admin/AdminLayout';
import StaffRoute from './components/staff/StaffRoute';
import StaffLayout from './components/staff/StaffLayout';
import PrinterRoute from './components/printer/PrinterRoute';
import PrinterLayout from './components/printer/PrinterLayout';
import PrinterOrderList from './components/printer/OrderList';
import PrinterPage from './components/printer/PrinterPage';
import UserLayout from './components/UserLayout';
import OrderManagement from './components/admin/OrderManagement';
import BatchManagement from './components/admin/BatchManagement';
import AirwayBillManagement from './components/admin/AirwayBillManagement';
import AirwayBillDetail from './components/orders/AirwayBillDetail';
import AirwayBillHistory from './components/orders/AirwayBillHistory';
import ImportHistoryPage from './components/orders/ImportHistoryPage';
import StaffManagement from './components/admin/StaffManagement';
import CustomerManagement from './components/admin/CustomerManagement';
import PortManagement from './components/admin/PortManagement';
import CourierManagement from './components/admin/CourierManagement';
import FinanceManagement from './components/admin/FinanceManagement';
import BillVerification from './components/admin/BillVerification';
import Logo from './components/Logo';
import { setAuthToken } from './utils/auth';
import './App.css';

// Check for token and set auth header
const token = localStorage.getItem('token');
if (token) {
  setAuthToken(token);
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Staff Routes */}
        <Route
          path="/staff"
          element={
            <StaffRoute>
              <StaffLayout />
            </StaffRoute>
          }
        >
          <Route index element={<Navigate to="/staff/orders" replace />} />
          <Route path="orders" element={<OrderManagement />} />
          <Route path="batches" element={<BatchManagement />} />
          <Route path="airwaybills" element={<AirwayBillManagement />} />
          <Route path="airwaybills/:id" element={<AirwayBillDetail />} />
          <Route path="customers" element={<CustomerManagement />} />
          <Route path="ports" element={<PortManagement />} />
          <Route path="couriers" element={<CourierManagement />} />
          <Route path="scan-print" element={<StaffScanPrint />} />
          <Route path="import" element={<OrderImportStaff />} />
          <Route path="import-history" element={<ImportHistoryPage />} />
          <Route path="exception" element={<ExceptionHandling />} />
          <Route path="tracking" element={<OrderTracking />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>

        {/* Printer Routes */}
        <Route
          path="/printer"
          element={
            <PrinterRoute>
              <PrinterLayout />
            </PrinterRoute>
          }
        >
          <Route index element={<Navigate to="/printer/orders" replace />} />
          <Route path="orders" element={<PrinterOrderList />} />
          <Route path="print" element={<PrinterPage />} />
        </Route>

        {/* Admin Routes */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<Navigate to="/admin/orders" replace />} />
          <Route path="orders" element={<OrderManagement />} />
          <Route path="batches" element={<BatchManagement />} />
          <Route path="airwaybills" element={<AirwayBillManagement />} />
          <Route path="airwaybills/:id" element={<AirwayBillDetail />} />
          <Route path="staff" element={<StaffManagement />} />
          <Route path="customers" element={<CustomerManagement />} />
          <Route path="ports" element={<PortManagement />} />
          <Route path="couriers" element={<CourierManagement />} />
          <Route path="bill-verification" element={<BillVerification />} />
          <Route path="finance" element={<FinanceManagement />} />
          <Route path="scan-print" element={
            <ManagerRoute>
              <AdminScanPrint />
            </ManagerRoute>
          } />
          <Route path="exception" element={<ExceptionHandling />} />
          <Route path="tracking" element={<OrderTracking />} />
          <Route path="import-history" element={<ImportHistoryPage />} />
        </Route>

        {/* Public Routes */}
        <Route path="/order-track" element={<PublicOrderTracking />} />
        <Route path="/login" element={
          <div className="App">
            <Logo />
            <Login />
          </div>
        } />
        <Route path="/register" element={
          <div className="App">
            <Logo />
            <Register />
          </div>
        } />

        {/* Protected User Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <UserLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/order-import" replace />} />
          <Route path="order-import" element={<OrderImport />} />
          <Route path="batch-management" element={<UserBatchManagement />} />
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="my-batches" element={<MyBatches />} />
          <Route path="tracking" element={<OrderTracking />} />
          <Route path="update-address" element={
            <CanUpdateAddressRoute>
              <UpdateAddress />
            </CanUpdateAddressRoute>
          } />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="scan-print" element={<CustomerScanPrint />} />
          <Route path="orders/import-history" element={<ImportHistoryPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
